import data from "./types/data";
import meta from "./types/meta";
import query from "./types/query";

const initialState = {
    data,
    query,
    meta
};

const beefProductBrandsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'beefProductBrands/update':
            return {
                ...state,
                ...action.payload
            };

        case 'beefProductBrands/clear':
            return initialState;

        default:
            return state;
    }
};

export default beefProductBrandsReducer;